import {
  centerItemFlex,
  getRelativeFontSize,
  inputLabelRequiredColor,
  mediumFont,
  regularFont,
  theme,
} from "../../utils/styles";

const pricingStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "20px",
    minHeight: "calc(100vh - 220px)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    marginY: "25px",
    maxWidth: "1750px",
    width: "100%",
  },
  subBox: {
    p: 3,
    minHeight: "calc(100vh - 260px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    // ...centerItemFlex,
    display: "grid",
    alignContent: "center",
    // overflowY: "auto",
    // overflowX: "hidden",
    // "&::-webkit-scrollbar": {
    //   width: "5px",
    // },
    // "&::-webkit-scrollbar-thumb": {
    //   borderRadius: "10px",
    //   border: "1px solid #FFFFFF",
    //   background: "#282945",
    // },
    [theme.breakpoints.down("sm")]: {
      p: 2,
    },
    // "@supports (-webkit-touch-callout: none)": {
    //   height: "calc(100vh - 270px)",
    // },
  },
  // mainBox: {
  //   p: 1,
  //   borderRadius: "20px",
  //   height: "calc(100vh - 220px)",
  //   boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
  //   background: "rgba(255, 255, 255, 0.07)",
  //   backdropFilter: "blur(12px)",
  //   border: "1px solid rgba(255, 255, 255, 0.14)",
  //   marginTop: "25px",
  //   maxWidth: "1750px",
  //   width: "100%",
  //   [theme.breakpoints.down("sm")]: {
  //     height: "calc(100vh - 222px)",
  //   },
  // },
  // subBox: {
  //   p: 3,
  //   height: "calc(100vh - 270px)",
  //   borderRadius: "20px",
  //   overflowY: "auto",
  //   overflowX: "hidden",
  //   "&::-webkit-scrollbar": {
  //     width: "5px",
  //   },
  //   "&::-webkit-scrollbar-thumb": {
  //     borderRadius: "10px",
  //     border: "1px solid #FFFFFF",
  //     background: "#282945",
  //   },
  //   border: "1px solid rgb(111 111 111 / 22%)",
  //   [theme.breakpoints.down("sm")]: {
  //     height: "calc(100vh - 240px)",
  //     p: 1,
  //   },
  // },
  priceBox: {
    borderRadius: "8px",
    background: "rgba(255, 255, 255, 0.14)",
    boxShadow: "inset 0 1000px rgba(255, 255, 255, .08)",
    px: 2,
    py: 4,
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  planText: {
    ...regularFont,
    fontSize: getRelativeFontSize(4),
    color: "#ffffff",
  },
  priceText: {
    ...mediumFont,
    fontSize: getRelativeFontSize(7),
    color: "#ffffff",
    lineHeight: 1,
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(4),
    },
  },
  realPriceText: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    textDecoration: "line-through",
    color: "#FFFFFF99",
    opacity: 0.85,
    letterSpacing: "0.5px",
    mr: 1,
    [theme.breakpoints.down("md")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  priceRadioBox: {
    flexDirection: "row-reverse",
    borderRadius: "12px",
    background: "rgba(255,255,255,0.10)",
    boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
    display: "flex",
    cursor: "pointer",
    p: "10px",
    position: "relative",
    overflow: "visible",
    width: "auto",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  discountBadge: {
    position: "absolute",
    top: -28,
    left: 10,
    display: "flex",
    alignItems: "center",
    gap: "6px",
    background: "linear-gradient(90deg, #ff6a00 0%, #ffb347 100%)",
    color: "#fff",
    fontWeight: 700,
    fontSize: "1rem",
    px: 2.2,
    py: 0.7,
    borderRadius: "999px",
    zIndex: 2,
    letterSpacing: "1px",
    textShadow: "0 1px 4px #b00020, 0 1px 2px #fff2",
    border: "2px solid #fff",
    boxShadow: "0 4px 16px 0 rgba(255,106,0,0.18)",
    minWidth: "70px",
    textAlign: "center",
    fontFamily: "Inter, Arial, sans-serif",
    transition: "all 0.2s cubic-bezier(.4,0,.2,1)",
    userSelect: "none",
    [theme.breakpoints.down("sm")]: {
      top: -16,
      left: 4,
      fontSize: "0.85rem",
      px: 1.2,
      py: 0.4,
      minWidth: "48px",
    },
  },
  selectedPriceRadioBox: {
    border: "2px solid #9053F6",
    background: "rgba(144, 83, 246, 0.12)",
    boxShadow: "0 0 16px 2px #9053F6AA",
  },
  priceRadioButton: {
    color: "#fff",
    // mr: 1.5,
    "&.Mui-checked": {
      color: "#9053F6",
    },
    "&.MuiRadio-root": {
      p: 0,
      ml: "12px",
      alignItems: "baseline",
    },
  },
  durationText: {
    ...mediumFont,
    fontSize: getRelativeFontSize(5),
    color: "#ffffff66",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  planDescText: {
    ...regularFont,
    fontSize: getRelativeFontSize(1),
    color: "#FFFFFF99",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  featuresText: {
    ...regularFont,
    fontSize: getRelativeFontSize(5),
    color: "#ffffff",
    display: "list-item",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  subscribeBtn: {
    py: 1.5,
    borderRadius: "8px",
    background: "#9053F6",
    width: "100%",
    maxWidth: "700px",
    textShadow: "0 1px 0 rgb(0 0 0 / 40%)",
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
    willChange: "box-shadow,transform",

    "&:hover": {
      boxShadow:
        "0px 0.1em 0.2em rgb(45 35 66 / 40%), 0px 0.4em 0.7em -0.1em rgb(45 35 66 / 30%), inset 0px -3px 0px #FDFDFD",
      transform: "translateY(-0.1em)",
      background: "#9053F6",
      color: "#FDFDFD",
    },
    "&:disabled": {
      background: "#c09aff",
    },
  },
  subscribeBtnTypo: {
    color: "#FDFDFD",
    ...mediumFont,
    fontSize: getRelativeFontSize(8),
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(4),
    },
  },
  loadingStyle: {
    color: "#000000",
    width: "25px !important",
    height: "25px !important",
  },
  cardElementStyle: {
    borderRadius: "8px",
    border: "1px solid #FFF",
    background: "rgba(255, 255, 255)",
    backdropFilter: "blur(5.5px)",
    p: 2,
  },
  inputLabels: {
    ...mediumFont,
    fontSize: getRelativeFontSize(4),
    color: "#FFFFFF",
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "40px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
    },
  },
  planBtn: {
    py: 1,
    borderRadius: "8px",
    background: "#FDFDFD",
    color: "#9053F6",
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    minWidth: "180px",
    textShadow: "0 1px 0 rgb(0 0 0 / 40%)",
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
    willChange: "box-shadow,transform",

    "&:hover": {
      boxShadow:
        "0px 0.1em 0.2em rgb(45 35 66 / 40%), 0px 0.4em 0.7em -0.1em rgb(45 35 66 / 30%), inset 0px -3px 0px #9053F6",
      transform: "translateY(-0.1em)",
      background: "#FDFDFD",
      color: "#9053F6",
    },

    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(1),
    },
  },
  selectedPlanBtn: {
    background: "#9053F6",
    color: "#FDFDFD",
    "&:hover": {
      boxShadow:
        "0px 0.1em 0.2em rgb(45 35 66 / 40%), 0px 0.4em 0.7em -0.1em rgb(45 35 66 / 30%), inset 0px -3px 0px #FDFDFD",
      transform: "translateY(-0.1em)",
      background: "#9053F6",
      color: "#FDFDFD",
    },
  },
  recommendedPlan: {
    height: "1px",
    zIndex: 2,
    textAlign: "end",
    position: "relative",
    pr: 3,
  },
  recommendsText: {
    ...regularFont,
    fontSize: getRelativeFontSize(1),
    color: "#FFFFFF",
    textAlign: "center",
    pb: 1,
  },
  filterBar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 2,
    py: 2,
    mb: 2,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: 1.5,
      py: 1.5,
    },
  },
  filterLabel: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "rgba(255, 255, 255, 0.85)",
    letterSpacing: "0.02em",
  },
  segmentedGroup: {
    display: "inline-flex",
    borderRadius: "14px",
    padding: "5px",
    background: "rgba(0, 0, 0, 0.25)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.2)",
    gap: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "stretch",
    },
  },
  currencyOption: {
    padding: "10px 22px",
    borderRadius: "10px",
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "rgba(255, 255, 255, 0.7)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    transition: "all 0.22s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      color: "rgba(255, 255, 255, 0.95)",
      background: "rgba(255, 255, 255, 0.06)",
    },
    "&:first-of-type": {
      marginRight: "2px",
    },
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      padding: "10px 16px",
      fontSize: getRelativeFontSize(1),
    },
  },
  currencyOptionSelected: {
    color: "#fff",
    background:
      "linear-gradient(145deg, rgba(144, 83, 246, 0.5) 0%, rgba(126, 58, 235, 0.4) 100%)",
    boxShadow:
      "0 2px 12px rgba(144, 83, 246, 0.35), 0 1px 0 rgba(255, 255, 255, 0.08) inset",
    "&:hover": {
      background:
        "linear-gradient(145deg, rgba(144, 83, 246, 0.55) 0%, rgba(126, 58, 235, 0.45) 100%)",
      color: "#fff",
    },
  },
  segmentedGroupLarge: {
    display: "inline-flex",
    borderRadius: "16px",
    padding: "8px",
    background: "rgba(0, 0, 0, 0.25)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.2)",
    gap: 0,
    marginTop: 2,
  },
  currencyOptionLarge: {
    padding: "14px 32px",
    borderRadius: "12px",
    ...mediumFont,
    fontSize: "28px",
    color: "rgba(255, 255, 255, 0.75)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    transition: "all 0.22s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      color: "rgba(255, 255, 255, 0.98)",
      background: "rgba(255, 255, 255, 0.08)",
    },
    "&:first-of-type": { marginRight: "4px" },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
      padding: "12px 24px",
    },
  },
  currencyOptionLargeSelected: {
    color: "#fff",
    background:
      "linear-gradient(145deg, rgba(144, 83, 246, 0.55) 0%, rgba(126, 58, 235, 0.45) 100%)",
    boxShadow:
      "0 2px 14px rgba(144, 83, 246, 0.4), 0 1px 0 rgba(255, 255, 255, 0.1) inset",
    "&:hover": {
      background:
        "linear-gradient(145deg, rgba(144, 83, 246, 0.6) 0%, rgba(126, 58, 235, 0.5) 100%)",
      color: "#fff",
    },
  },
  pricingInfoModalHeader: {
    ...mediumFont,
    fontSize: getRelativeFontSize(10),
    color: "#1a1a2e",
    textAlign: "center",
    letterSpacing: "0.02em",
  },
  pricingInfoModalIntro: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "#555",
    textAlign: "center",
    lineHeight: 1.65,
    px: 1,
  },
  pricingInfoNoteCard: {
    borderRadius: "14px",
    border: "1px solid rgba(144, 83, 246, 0.2)",
    background:
      "linear-gradient(135deg, rgba(144, 83, 246, 0.06) 0%, rgba(255, 255, 255, 0.95) 100%)",
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    p: 2.5,
    position: "relative" as const,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "4px",
      background:
        "linear-gradient(180deg, #9053F6 0%, #7C3AED 50%, #6366F1 100%)",
      borderRadius: "4px 0 0 4px",
    },
  },
  pricingInfoNoteCardTitle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    color: "#1a1a2e",
    mb: 1.5,
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  pricingInfoNoteCardBadge: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #9053F6 0%, #7C3AED 100%)",
    color: "#fff",
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  pricingInfoModalContent: {
    fontSize: getRelativeFontSize(2),
    ...regularFont,
    color: "#374151",
    lineHeight: 1.75,
  },
  pricingInfoModalNoteTitle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    color: "#2d2d44",
    mt: 2,
    mb: 1,
  },
  pricingInfoBillingRow: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.06)",
    background: "#fafafa",
    p: 1.5,
    pl: 2,
    mb: 1.5,
    borderLeft: "3px solid #9053F6",
  },
  pricingInfoBillingLabel: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#1a1a2e",
    mb: 0.5,
  },
  pricingInfoBlikHighlight: {
    ...mediumFont,
    backgroundColor: "rgba(144, 83, 246, 0.15)",
    color: "#5B21B6",
    px: 1,
    py: 0.25,
    borderRadius: "6px",
    fontWeight: 600,
  },
  pricingInfoGotItBtn: {
    background: "linear-gradient(135deg, #9053F6 0%, #7C3AED 100%)",
    borderRadius: "12px",
    minWidth: "180px",
    height: "52px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
    color: "#fff",
    boxShadow: "0 4px 14px rgba(144, 83, 246, 0.4)",
    "&:hover": {
      background: "linear-gradient(135deg, #9F67F8 0%, #8B5CF6 100%)",
      boxShadow: "0 6px 20px rgba(144, 83, 246, 0.5)",
    },
  },
  billingOption: {
    padding: "8px 18px",
    borderRadius: "10px",
    ...mediumFont,
    fontSize: getRelativeFontSize(1),
    color: "rgba(255, 255, 255, 0.7)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    transition: "all 0.22s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      color: "rgba(255, 255, 255, 0.95)",
      background: "rgba(255, 255, 255, 0.06)",
    },
    "&:first-of-type": {
      marginRight: "2px",
    },
  },
  billingOptionSelected: {
    color: "#fff",
    background:
      "linear-gradient(145deg, rgba(136, 118, 240, 0.45) 0%, rgba(124, 102, 230, 0.35) 100%)",
    boxShadow:
      "0 2px 10px rgba(136, 118, 240, 0.3), 0 1px 0 rgba(255, 255, 255, 0.06) inset",
    "&:hover": {
      background:
        "linear-gradient(145deg, rgba(136, 118, 240, 0.5) 0%, rgba(124, 102, 230, 0.4) 100%)",
      color: "#fff",
    },
  },
  billingSegmentedGroup: {
    display: "inline-flex",
    borderRadius: "12px",
    padding: "4px",
    background: "rgba(0, 0, 0, 0.2)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.15)",
    gap: 0,
  },
  label: { display: "flex", height: "20px" },
  labelText: {
    color: "#FFFFFF",
    marginLeft: "6px",
    ...mediumFont,
    fontSize: getRelativeFontSize(3),
  },
  star: {
    color: inputLabelRequiredColor,
    marginLeft: "2px",
    fontSize: getRelativeFontSize(5),
  },
  textField: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #FFF",
    background: "rgba(255, 255, 255)",
    backdropFilter: "blur(5.5px)",

    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 12px",
      color: "#000000",
      "&::placeholder": {
        ...regularFont,
        color: "#000000AF",
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      borderColor: "#FFFFFF",
      "&.Mui-focused fieldset": {
        border: 0,
      },
    },
  },
  normalTypo: {
    ...regularFont,
    fontSize: getRelativeFontSize(5),
    color: "#ffffffc7",
    letterSpacing: "1px",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  boldTypo: {
    ...mediumFont,
    fontSize: getRelativeFontSize(5),
    color: "#ffffff",
    letterSpacing: "1px",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(2),
    },
  },
  dividerStyle: {
    border: "1px solid #ffffff",
    width: "30%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  invoiceDetailsMainBox: {
    borderRadius: "24px",
    border: "1px solid rgba(255, 255, 255, 0.10)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(-1px)",
    width: "100%",
    // height: "50px",
    p: 1,
  },
  invoiceDetailsSubBox: {
    borderRadius: "16px",
    border: "1px solid rgba(255, 255, 255, 0.10)",
    background:
      "radial-gradient(70.71% 70.71% at 50% 50%, rgba(168, 127, 255, 0.04) 0%, rgba(168, 127, 255, 0.00) 100%), rgba(4, 1, 21, 0.10)",
    backdropFilter: "blur(-1px)",
    width: "100%",
    // height: "48px",
  },
  titleTypo: {
    ...regularFont,
    fontSize: getRelativeFontSize(2),
    color: "#ffffffc7",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  valueTypo: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  footer: {
    ...centerItemFlex,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
    },
  },
  footerTypo: {
    ...mediumFont,
    fontSize: getRelativeFontSize(0),
    textAlign: "center",
    color: "#FFFFFF",
  },
  content: {
    width: "100%",
    minHeight: "calc(100vh - 165px)",
    height: "auto",
    marginTop: "120px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "100px",
      minHeight: "calc(100vh - 100px)",
    },
  },
} as const;

export default pricingStyles;
